import { render, staticRenderFns } from "./SlackChooseChannelButton.vue?vue&type=template&id=60a32e30&"
import script from "./SlackChooseChannelButton.vue?vue&type=script&lang=js&"
export * from "./SlackChooseChannelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports